import { useEffect } from "react";
import { loadCardsThunk } from "../modules/cardReducer";

// 여기서 데이터 베이스 만드는것은 안 좋아 보임
// 그러나 database off clean up 은 어떻게 처리할 것인가..??

// const database = new Database();
const useDatabase = (dispatch, userId) => {
  useEffect(() => {
    if (userId == null) return;

    dispatch(loadCardsThunk(userId));
  }, [dispatch, userId]);
};

export default useDatabase;
